import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AnalyticsEvent, AnalyticsService } from './analytics-service';
import { AppConfig } from './app-config.service';

@Injectable({
  providedIn: 'root',
})
export class PdfService {
  constructor(private appConfig: AppConfig, private http: HttpClient, private analyticsService: AnalyticsService) {}

  public getConfirmationUrl(paymentId: string, liabilityId: string): Observable<string> {
    this.analyticsService.trackEvent(new AnalyticsEvent('DownloadPaymentConfirmation'));
    const url = this.appConfig.config.apiUrl + `/payments/${paymentId}/payment-fragments/${liabilityId}/confirmation`;
    return this.getPdfData(url);
  }

  public clearConfirmationUrl(url: string) {
    URL.revokeObjectURL(url);
  }

  private getPdfData(url: string): Observable<string> {
    const headers = new HttpHeaders().set('Accept', 'application/octet-stream');

    return this.http.get(url, { headers, observe: 'response', responseType: 'blob' }).pipe(
      map((response) => {
        const blob = new Blob([response.body], { type: 'application/pdf' });
        return URL.createObjectURL(blob);
      }),
    );
  }
}
